import { Paper } from '@mui/material';
import { LAYOUT } from '@/constants/layout';

interface LogFrameProps {
  children: React.ReactNode;
}

const LogFrame = ({ children }: LogFrameProps) => {
  return (
    <Paper sx={{ 
      p: LAYOUT.PADDING.MEDIUM / 8,
      height: '100%',
      overflow: 'auto'
    }}>
      {children}
    </Paper>
  );
};

export default LogFrame; 